<template>
  <div class="pa-5" v-if="form_resources">
    <v-card class="elevataion-10">
      <v-card-title>{{ title }}ประกาศ</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="form.no"
              label="เลขที่ประกาศ"
              placeholder="1/2564"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <v-select
              v-model="form.position_type_id"
              label="ประเภทตำแหน่ง"
              :items="form_resources.staff_types"
              item-text="name_th"
              item-value="id"
              outlined
              dense
              hide-details="auto"
            ></v-select>
          </v-col>
        </v-row>
        
        <v-text-field
          v-model="form.title"
          label="ชื่อประกาศ"
          hide-details="auto"
          outlined
          dense
        ></v-text-field>

        <v-row>
          <v-col cols="6" class="py-0">
            <v-subheader class="px-0 font-weight-bold">วันที่เปิดรับสมัคร:</v-subheader>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="form.start_date"
                  label="วัน/เดือน/ปี(ค.ศ.)"
                  placeholder="31/01/2021"
                  v-mask="'##/##/####'"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>              
              <v-col cols="6">
                <v-text-field
                  v-model="form.start_time"
                  label="เวลา"
                  placeholder="08:00"
                  v-mask="'##:##'"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-subheader class="px-0 font-weight-bold">วันที่ปิดรับสมัคร:</v-subheader>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="form.end_date"
                  label="วัน/เดือน/ปี(ค.ศ.)"
                  placeholder="31/01/2021"
                  v-mask="'##/##/####'"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.end_time"
                  label="เวลา"
                  placeholder="08:00"
                  v-mask="'##:##'"
                  dense
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-subheader class="px-0 font-weight-bold">ตำแหน่ง:</v-subheader>
        <v-simple-table class="mb-5 table-bordered">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 20%">ตำแหน่ง</th>
                <th style="width: 20%">หน่วยงาน</th>
                <th style="width: 20%">หน่วยงานย่อย</th>
                <th style="width: 10%">เงินเดือน</th>
                <th style="width: 10%">จำนวน</th>
                <th style="width: 15%">รายละเอียดเพิ่มเติม</th>
                <th style="width: 5%">#</th>
              </tr>
            </thead>

            <v-slide-y-transition
              group
              tag="tbody"
            >
              <tr v-for="(job, index) in form.jobs" :key="index">
                <td>
                  <v-autocomplete
                    v-model="job.position_work_id"
                    :items="form_resources.position_types"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    label="ตำแหน่ง"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-autocomplete>
                </td>
                <td>
                  <v-select
                    v-model="job.department_id"
                    outlined
                    dense
                    :items="form_resources.departments"
                    label="หน่วยงาน"
                    item-text="name" 
                    item-value="id" 
                    hide-details="auto"
                    @change="getSubDepartments($event, job)"
                  ></v-select>
                </td>
                <td>
                  <v-select
                    v-model="job.sub_department_id"
                    outlined
                    :items="job.sub_departments"                    
                    label="หน่วยงานย่อย"
                    dense
                    item-text="name" 
                    item-value="id" 
                    hide-details="auto"
                  ></v-select>
                </td>
                <td>
                  <v-text-field
                    class="my-2 py-0"
                    v-model="job.salary"
                    placeholder="15000"
                    dense
                    outlined
                    :rules="[rules.salary.number]"
                    hide-details="auto"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    class="my-2 py-0"
                    v-model="job.qty"
                    type="number"
                    min="1"
                    dense
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    class="my-2 py-0"
                    v-model="job.description"
                    dense
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </td>
                <td>
                  <v-btn color="error" v-if="index > 0" @click="remove_job(index)"><v-icon small>mdi-close</v-icon>ลบ</v-btn>
                </td>
              </tr>
          
            </v-slide-y-transition>
            
            <tbody>
              <v-btn class="ma-2" color="success" small @click="add_job"><v-icon small>mdi-plus</v-icon>เพิ่มตำแหน่ง</v-btn>
            </tbody>
          </template>
        </v-simple-table>

        <v-file-input
          v-model="form.file"
          label="แนบไฟล์ประกาศ"
          outlined
          dense
          hide-details="auto"
        >
        </v-file-input>

        
      </v-card-text>

      <v-card-actions>
        <v-btn 
          color="primary" 
          block
          @click="submit"
        >
          {{ title }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    ref_position_work_loading: false,
    sub_departments: [],
    form: {
      no: '',
      title: '',
      position_type_id: '',
      file: null,
      start_date: '',
      start_time: '',
      end_date: '',
      end_time: '',
      jobs: [
        {
          department_id: '',
          sub_department_id: '',
          position_work_id: '',
          qty: '',
          salary: '',
          description: ''
        }
      ],
      deleted: []
    },
    search: null,
    rules: {
      salary: {
        number: value => !isNaN(value) || 'ระบุเป็นตัวเลขเท่านั้น'
      }
    }
  }),
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('job/edit', this.$route.params.id)
        .then(res => {
          this.form.id = res.id;
          this.form.no = res.no;
          this.form.title = res.title;
          this.form.position_work_id = res.position_work_id;
          this.form.start_date = res.start_date;
          this.form.start_time = res.start_time;
          this.form.end_date = res.end_date;
          this.form.end_time = res.end_time;
          this.form.jobs = res.jobs.map(job => {
            job.sub_departments = this.form_resources.sub_departments.filter(item => item.department_id === job.department_id);

            return job;
          });
        })
    }
  },
  computed: {
    title() { return this.$route.meta.form_title },
    form_resources() { return this.$store.state.job.resources },
    form_type() { return this.$route.meta.form_type },
    // staff_types() { return this.$store.state.document.staff_types },
    // departments() { return this.$store.state.departments },
    // position_works() { return this.$store.state.position_works },    
  },
  watch: {
    form_resources: {
      handler(val) {
        if(!val) {
          this.$store.dispatch('job/get_resources');
        }
      },
      immediate: true
    }
  },
  methods: {
    add_job() {
      this.form.jobs.push({
        department_id: '',
        sub_department_id: '',
        position_work_id: '',
        qty: '',
        salary: '',
        description: ''
      })
    },
    remove_job(idx) {
      if(this.form_type === 'EDIT') {
        this.form.deleted.push(this.form.jobs[idx]);
      }
      this.form.jobs.splice(idx, 1);


    },
    submit() {
      this.$store.dispatch(this.form_type === 'NEW' ? 'job/store': 'job/update', this.form_data(this.form))
        .then(res => {
          this.$store.commit('SHOW_SNACKBAR', { color: 'success', message: res.message });
          this.$router.push({ name: 'JobAnnouncement' });
        })
        .catch(() => {
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'error',
            message: 'เกิดข้อผิดพลาดบางอย่าง'
          });
        });
    },
    getSubDepartments(department_id, job) {
      job.sub_departments = this.form_resources.sub_departments.filter(item => item.department_id === department_id);
    },
    form_data(form) {
      const form_data = new FormData;

      if(form.id) {
        form_data.append('id', form.id);
      }

      form_data.append('no', form.no);
      form_data.append('title', form.title);
      form_data.append('start_date', form.start_date);
      form_data.append('start_time', form.start_time);
      form_data.append('end_date', form.end_date);
      form_data.append('end_time', form.end_time);
      form_data.append('position_type_id', form.position_type_id);

      if(form.jobs && form.jobs.length > 0) {
        form_data.append('jobs', JSON.stringify(form.jobs));
      }

      if(form.deleted && form.deleted.length > 0) {
        form_data.append('deleted', JSON.stringify(form.deleted));
      }

      if(form.file) {
        form_data.append('file', form.file);
      }

      return form_data;
    }
  }
}
</script>